// Format LocalTime with +0n00
// Example result: "2024-10-14T16:59:02+0300"
// If the offset is 0 then it's utc: "2024-10-14T16:59:02Z"
export function toISOStringWithTimeZoneOffset(x) {
    const pad = (num) => (num < 10 ? '0' : '') + num;
    const offset = -x.getTimezoneOffset();
    const sign = offset >= 0 ? '+' : '-';
    const hoursOffset = pad(Math.floor(Math.abs(offset) / 60));
    const minutesOffset = pad(Math.abs(offset) % 60);
    const datePart = `${x.getFullYear()}-${pad(x.getMonth() + 1)}-${pad(x.getDate())}`;
    const timePart = `${pad(x.getHours())}:${pad(x.getMinutes())}:${pad(x.getSeconds())}`;
    const offsetPart = offset == 0 ? 'Z' : `${sign}${hoursOffset}${minutesOffset}`;
    return `${datePart}T${timePart}${offsetPart}`;
}
